import { render, staticRenderFns } from "./FormQuestionEditor.vue?vue&type=template&id=0c981d84"
import script from "./FormQuestionEditor.vue?vue&type=script&lang=js"
export * from "./FormQuestionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports